import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const SET_CATEGORY_TYPES = "SET_CATEGORY_TYPES";
export const SET_PRODUCT_CATEGORY_TYPES = "SET_PRODUCT_CATEGORY_TYPES";
export const SET_MATERIAL_CATEGORY_TYPES = "SET_MATERIAL_CATEGORY_TYPES";
export const SET_CATEGORY_TYPES_LOADING = "SET_CATEGORY_TYPES_LOADING";
export const SET_CATEGORY_TYPES_ERROR = "SET_CATEGORY_TYPES_ERROR";

const setError = (dispatch, error) => {
  dispatch({
    type: SET_CATEGORY_TYPES_ERROR,
    error: error?.response?.data?.message || error?.message || "Terjadi kesalahan pada data tipe.",
  });
};

const getSetType = (type) => {
  if (type === "product") return SET_PRODUCT_CATEGORY_TYPES;
  if (type === "material") return SET_MATERIAL_CATEGORY_TYPES;

  return SET_CATEGORY_TYPES;
};

export const fetchCategoryTypes = (limit = 100, page = 1, search = "", params = {}) => async (dispatch) => {
  dispatch({ type: SET_CATEGORY_TYPES_LOADING, status: true });
  try {
    const response = await authorizedAxios.get("/category-types", {
      params: { limit, page, search, ...params },
    });
    dispatch({ type: getSetType(params?.type), data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_CATEGORY_TYPES_LOADING, status: false });
  }
};

export const fetchProductCategoryTypes = (limit = 100, page = 1, search = "", params = {}) =>
  fetchCategoryTypes(limit, page, search, { ...params, type: "product" });

export const fetchMaterialCategoryTypes = (limit = 100, page = 1, search = "", params = {}) =>
  fetchCategoryTypes(limit, page, search, { ...params, type: "material" });

export const addCategoryType = (data) => async (dispatch) => {
  dispatch({ type: SET_CATEGORY_TYPES_LOADING, status: true });
  try {
    await showToast(authorizedAxios.post("/category-types", data), {
      loading: "Menyimpan tipe...",
      success: "Tipe berhasil ditambahkan!",
      error: (error) => error?.response?.data?.message || "Gagal menyimpan tipe!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_CATEGORY_TYPES_LOADING, status: false });
  }
};

export const updateCategoryType = (id, data) => async (dispatch) => {
  dispatch({ type: SET_CATEGORY_TYPES_LOADING, status: true });
  try {
    await showToast(authorizedAxios.put(`/category-types/${id}`, data), {
      loading: "Memperbarui tipe...",
      success: "Tipe berhasil diperbarui!",
      error: (error) => error?.response?.data?.message || "Gagal memperbarui tipe!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_CATEGORY_TYPES_LOADING, status: false });
  }
};

export const deleteCategoryType = (id) => async (dispatch) => {
  dispatch({ type: SET_CATEGORY_TYPES_LOADING, status: true });
  try {
    await showToast(authorizedAxios.delete(`/category-types/${id}`), {
      loading: "Menghapus tipe...",
      success: "Tipe berhasil dihapus!",
      error: (error) => error?.response?.data?.message || "Gagal menghapus tipe!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_CATEGORY_TYPES_LOADING, status: false });
  }
};
